export default __webpack_public_path__ + "bf539c5db41d7ea9210a84c7b6ea0e72.png";